<template lang="pug">
  .dashboard-contain
    .dashboard-contain-left
      .dashboard-contain-nav
        .nav-item(:class="{'active' : Board === 'list'}" @click="SETBOARD('list')")
          .material-icons list
          span to-do list
        .nav-item(:class="{'active' : Board === 'analytics'}" @click="SETBOARD('analytics')")
          .material-icons insert_chart
          span analytics
        .nav-item(:class="{'active' : Board === 'ringtones'}" @click="SETBOARD('ringtones')")
          .material-icons library_music
          span ringtones
      .dashboard-contain-now
        router-link.contain-now-play(to="/")
          .material-icons play_circle_filled
        .contain-now-time {{ Math.floor(Todo.work_time / 60) < 10 ? '0' : '' }}{{ Math.floor(Todo.work_time / 60) }}:{{ Math.floor(Todo.work_time % 60) < 10 ? '0' : '' }}{{ Math.floor(Todo.work_time % 60) }}
        .contain-now-title {{ Todo.title }}
    .dashboard-contain-middle(v-if="Board==='list'")
      .dashboard-admision
          input(placeholder="ADD A NEW MISSION..." @keyup.enter="addTodo")
          .material-icons add
      .dashboard-todo-toggle(@click="toggleDrop('todo')")
        a(href="#") To-do
        .material-icons(v-if="!toggle && target === 'todo'") arrow_drop_up
        .material-icons(v-else) arrow_drop_down
      ul.dashboard-todo-drop(:class="{'toggle': toggle && target === 'todo'}")
        li(v-for="todo in AllList" :key="todo.id")
          .material-icons(@click="done(todo)") radio_button_unchecked
          .drop-title {{ todo.title }}
          .material-icons(@click="SIWTCHTODO(todo); route()") play_circle_outline
      .dashboard-todo-toggle(@click="toggleDrop('done')")
        a(href="#") done
        .material-icons(v-if="!toggle && target === 'done'") arrow_drop_up
        .material-icons(v-else) arrow_drop_down
      ul.dashboard-todo-drop(:class="{'toggle': toggle && target === 'done'}")
        li(v-for="todo in DoneList" :key="todo.id")
          .material-icons(style="cursor: default") check_circle_outline
          .drop-title.done {{ todo.title }}
          .circle(v-for="num in todo.pomodoro" :key="num")
    .dashboard-contain-middle(v-if="Board==='ringtones'")
      .dashboard-todo-toggle(style="margin-top: 0")
        a(href="#") WORK
      ul.ringtones
        li(v-for="ring in WorkRing" :key="ring.title" @click="SETRING({type: 'work_rings', ring})")
          .material-icons(v-if="!ring.selected") radio_button_unchecked
          .material-icons(v-else style="color: #FF4384") radio_button_checked
          span {{ ring.title }}
      .dashboard-todo-toggle
        a(href="#") BREak
      ul.ringtones
        li(v-for="ring in BreakRing" :key="ring.title" @click="SETRING({type: 'break_rings', ring})")
          .material-icons(v-if="!ring.selected") radio_button_unchecked
          .material-icons(v-else style="color: #FF4384") radio_button_checked
          span {{ ring.title }}
    .dashboard-contain-middle(v-if="Board==='analytics'")
      p(style="font-size: 50px; color:white;") comming soon...
    .dashboard-contain-right
      router-link(to="/").material-icons close
      span.pomodoro-contain-title POMODORO
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      toggle: false,
      target: ''
    }
  },
  methods: {
    ...mapActions(['addTodo']),
    ...mapMutations(['SETBOARD', 'UPDATETODOLIST', 'SIWTCHTODO', 'SETRING']),
    toggleDrop (target) {
      this.toggle = !this.toggle
      this.target = target
    },
    done (todo) {
      todo.completed = !todo.completed
      this.UPDATETODOLIST(todo)
    },
    route () {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters(['Todo', 'Board', 'AllList', 'DoneList', 'WorkRing', 'BreakRing'])
  }
}
</script>
